const parseToHtml = content => {
  return new DOMParser().parseFromString(content, "text/html");
};

export { parseToHtml };
